import api from '../api/axiosConfig';

export const usersApi = {
    getList: async (skip = 0, limit = 20) => {
        const response = await api.get('auth/get_users', {
            params: { skip, limit },
            silent: true
        });
        return response.data.data;
    },
};

export const userOrganisationsApi = {
    getUserOrganisations: async (user_id) => {
        const response = await api.get(`/user_organisations/users/${user_id}/organisations`, {
            silent: true
        });
        return response.data.data;
    },
    getListUsersByOrganisationId: async (org_id) => {
        const response = await api.get(`/user_organisations/${org_id}/users`, {
            silent: true
        });
        return response.data.data;
    },
    getListUsersByOrganisationIds: async (org_ids) => {
        // Новый метод для получения пользователей по массиву ID организаций
        const response = await api.get(`/user_organisations/users`, {
            params: { org_ids },
            silent: true,
            paramsSerializer: (params) => {
                const parts = [];
                if (Array.isArray(params.org_ids)) {
                    params.org_ids.forEach(id => {
                        parts.push(`org_ids=${encodeURIComponent(Number(id))}`);
                    });
                }
                return parts.join('&');
            }
        });
        return response.data.data;
    },
};